<template>
  <input
    :id="id"
    v-model="address"
    type="text"
    required="required"
    class="inputstyle col-md-7 fontSize16"
    placeholder="輸入地址"
    ref="valueData"
  />
</template>
<script>
//@keydown.stop.prevent.enter="searchAddress"
import Cookies from 'js-cookie'
import GoogleMapsLoader from 'google-maps'
import { ApiKey } from '../../assets/js/libs/GoogleAPI'
export default {
  props: ['id', 'area'],
  name: 'auto-complete',
  data() {
    return {
      areaDistrict: null,
      autoComplete: null,
      geocoder: null,
      address: this.area,
      autolocation: {
        address: null,
        latitude: null,
        longitude: null,
      },
      inputlocation: {
        address: null,
        latitude: null,
        longitude: null,
      },
    }
  },
  mounted() {
    GoogleMapsLoader.KEY = ApiKey()
    GoogleMapsLoader.LIBRARIES = ['geometry', 'places', 'geocoder']
    GoogleMapsLoader.load((google) => {
      this.initPlaceMap()
      this.initGeoMap()
    })
  },
  methods: {
    initGeoMap() {
      this.geocoder = new google.maps.Geocoder()
    },
    initPlaceMap() {
      const input = document.getElementById(this.id)
      this.autoComplete = new google.maps.places.Autocomplete(input)
      this.autoinput(this.autoComplete)
    },
    autoinput(autocomplete) {
      autocomplete.addListener('place_changed', () => {
        var place = autocomplete.getPlace()
        if (place.address_components !== undefined) {
          let removedAddressKey = place.formatted_address
            .trim()
            .replace(/\s/, '')
            .replace(/^\d+/, '')
          if (removedAddressKey.slice(0, 2) === '台灣') {
            removedAddressKey = removedAddressKey.slice(
              2,
              removedAddressKey.length,
            )
          }
          this.address = removedAddressKey + '(' + place.name + ')'
          this.autolocation.address = removedAddressKey + '(' + place.name + ')'
          this.autolocation.latitude = place.geometry.location.lat()
          this.autolocation.longitude = place.geometry.location.lng()
          this.transferData(this.autolocation)
        }
      })
    },
    searchAddress() {
      this.geocoder.geocode({ address: this.address }, (results, status) => {
        if (status === 'OK') {
          this.inputlocation.latitude = results[0].geometry.location.lat()
          this.inputlocation.longitude = results[0].geometry.location.lng()
          this.inputlocation.address = results[0].formatted_address
          this.$emit('onLocationData', this.inputlocation)
          this.inputlocation.address = null
          this.inputlocation.latitude = null
          this.inputlocation.longitude = null
        } else {
          alert('請無此地址')
        }
      })
    },
    geocodeAddress(geocoder, resultsMap) {
      return new Promise((resolve, reject) => {
        geocoder.geocode({ address: this.address }, (results, status) => {
          if (status === 'OK') {
            this.inputlocation.latitude = results[0].geometry.location.lat()
            this.inputlocation.longitude = results[0].geometry.location.lng()
            this.inputlocation.address = this.address
            resolve(this.address)
          } else {
            alert('請填選地址')
          }
        })
      })
    },
    clearAddress(val) {
      this.address = ''
      this.address = val
    },
    transferData(val) {
      this.geocodeAddress(this.geocoder)
        .then((value) => {
          if (val.address !== null) {
            this.$emit('onLocationData', val)
          } else if (this.inputlocation !== null) {
            this.$emit('onLocationData', this.inputlocation)
            this.inputlocation.address = null
            this.inputlocation.latitude = null
            this.inputlocation.longitude = null
          } else {
            alert('請填選上車地址')
          }
        })
        .catch(function (error) {
          console.log('--->', error)
        })
    },
    // setAddress(val){
    //     this.address = val
    // },
    getAddress() {
      if (this.inputlocation.latitude === null || this.inputlocation.latitude) {
        if (this.address.length > 3) {
          return this.address
        } else {
          return null
        }
      }
      let removedAddressKey = this.address
        .trim()
        .replace(/\s/, '')
        .replace(/^\d+/, '')
      if (removedAddressKey.slice(0, 2) === '台灣') {
        removedAddressKey = removedAddressKey.slice(2, removedAddressKey.length)
      }
      return removedAddressKey
    },
  },
  watch: {
    area: function () {
      // console.log(this.area)
      this.address = this.area
    },
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/mapComponent/AutoComplete.vue